export default "__VITE_ASSET__35634942__"